var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "286px",
    height: "286px",
    viewBox: "0 0 286 286",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.12,74 L166.482976,74 L201,103.365178 L201,192.88 C201,204.544254 191.544254,214 179.88,214 L110.12,214 C98.4557461,214 89,204.544254 89,192.88 L89,95.12 C89,83.4557461 98.4557461,74 110.12,74 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-14",
    fill: "#F4F5F9",
    cx: 143,
    cy: 143,
    r: 143
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-45"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C3C9D0",
    strokeWidth: 9.24,
    d: "M196.38,105.500441 L164.783636,78.62 L110.12,78.62 C101.007302,78.62 93.62,86.0073016 93.62,95.12 L93.62,192.88 C93.62,201.992698 101.007302,209.38 110.12,209.38 L179.88,209.38 C188.992698,209.38 196.38,201.992698 196.38,192.88 L196.38,105.500441 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121,181 C128.198061,173 136.864727,169 147,169 C157.135273,169 165.801939,173 173,181",
    id: "Line-7",
    stroke: "#F7C32F",
    strokeWidth: 9.24,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Line-8",
    stroke: "#C3C9D0",
    strokeWidth: 9.24,
    strokeLinecap: "square",
    points: "159 81.777695 159 111 189 111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPlaceholder);
export default __webpack_public_path__ + "static/media/empty-placeholder.b64ef65f00d88ce7cf4958103200e115.svg";
export { ForwardRef as ReactComponent };